module.exports = __webpack_public_path__ + "static/media/Sub 12.d937337e.JPG";